module.exports = __webpack_public_path__ + "5d2dd2895a8acf45d39fa369d0216ec5.svg";